import ar from "./ar.json";
import en from "./en.json";

export const SUPPORTED_LOCALES = ["ar", "en"] as const;
export const DEFAULT_LOCALE = "ar";

export type Locale = (typeof SUPPORTED_LOCALES)[number];

const messages = { ar, en } as const;

export type Messages = typeof ar;

const FALLBACK = ar;

/**
 * Resolve a deep-keyed translation: t("nav.search") → "البحث"
 *
 * Falls back to Arabic if the key is missing in the requested locale.
 * Returns the key itself if missing in both — useful in dev to spot gaps.
 */
export function t(locale: Locale, key: string): string {
  const dict = messages[locale] ?? FALLBACK;
  const value = key.split(".").reduce<unknown>((acc, k) => {
    if (acc && typeof acc === "object" && k in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[k];
    }
    return undefined;
  }, dict);
  if (typeof value === "string") return value;
  // fallback to Arabic
  const fb = key.split(".").reduce<unknown>((acc, k) => {
    if (acc && typeof acc === "object" && k in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[k];
    }
    return undefined;
  }, FALLBACK);
  return typeof fb === "string" ? fb : key;
}

export function dirFor(locale: Locale): "rtl" | "ltr" {
  return locale === "ar" ? "rtl" : "ltr";
}

export function isRtl(locale: Locale): boolean {
  return dirFor(locale) === "rtl";
}

export function detectLocale(acceptLanguage: string | null | undefined): Locale {
  if (!acceptLanguage) return DEFAULT_LOCALE;
  const lower = acceptLanguage.toLowerCase();
  if (lower.startsWith("en")) return "en";
  return "ar";
}
